{
  "name": "@reuvenorg/israel-statistics-mcp",
  "version": "1.1.0",
  "description": "Model Context Protocol (MCP) server for Israeli Central Bureau of Statistics (CBS) price indices and economic data. Provides 9 tools for retrieving, analyzing, and calculating Israeli economic statistics including CPI, housing prices, producer indices, and inflation calculations.",
  "mcpName": "io.github.reuvenaor/israel-statistics-mcp",
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "module": "./dist/index.js",
  "bin": {
    "israel-statistics-mcp": "./dist/index.js",
    "israstat-mcp": "./dist/index.js"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "packageManager": "pnpm@10.15.0",
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "author": {
    "name": "reuvenaor",
    "email": "contact@reuvenaor.com",
    "url": "https://reuvenaor.com"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/reuvenaor/israel-statistics-mcp.git"
  },
  "sideEffects": false,
  "bugs": {
    "url": "https://github.com/reuvenaor/israel-statistics-mcp/issues"
  },
  "homepage": "https://github.com/reuvenaor/israel-statistics-mcp#readme",
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "keywords": [
    "mcp",
    "israel",
    "statistics",
    "cbs",
    "cpi",
    "inflation",
    "economic-data",
    "price-index",
    "housing-prices",
    "model-context-protocol",
    "israeli-economy",
    "consumer-price-index",
    "producer-price-index",
    "construction-index",
    "agriculture-index",
    "typescript",
    "api-client",
    "economic-analysis",
    "statistical-data"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "clean": "rimraf dist && rimraf components",
    "start": "node dist/index.js",
    "prepublishOnly": "pnpm run clean && pnpm run build && pnpm run typecheck && pnpm run test",
    "format:write": "prettier --write \"**/*.{ts,tsx,mdx}\" --cache",
    "format:check": "prettier --check \"**/*.{ts,tsx,mdx}\" --cache",
    "lint": "eslint src",
    "lint:fix": "eslint src --fix",
    "test": "vitest run --project unit",
    "test:live": "vitest run --project live",
    "test:coverage": "vitest run --project unit --coverage",
    "smoke": "node scripts/smoke.mjs",
    "changeset": "changeset",
    "changeset:version": "changeset version",
    "changeset:publish": "changeset publish",
    "prepare": "husky || exit 0",
    "version": "changeset version && pnpm install --lockfile-only",
    "release": "pnpm run build && changeset publish"
  },
  "lint-staged": {
    "src/**/*.ts": [
      "prettier --write",
      "eslint --fix"
    ],
    "*.{json,md,yml,yaml,mjs,cjs}": "prettier --write"
  },
  "pnpm": {
    "overrides": {
      "fast-uri": ">=3.1.5",
      "ip-address": ">=10.3.1",
      "hono": ">=4.12.34",
      "@hono/node-server": ">=2.0.5",
      "postcss": ">=8.5.23",
      "brace-expansion": ">=5.0.9",
      "esbuild": ">=0.28.1"
    }
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.30.0",
    "xml2js": "^0.6.2",
    "zod": "^3.25.76"
  },
  "devDependencies": {
    "@changesets/cli": "^2.31.0",
    "@eslint/js": "^10.0.1",
    "@types/node": "^24.13.2",
    "@types/xml2js": "^0.4.14",
    "@vitest/coverage-v8": "^4.1.9",
    "eslint": "^10.6.0",
    "eslint-config-prettier": "^10.1.8",
    "husky": "^9.1.7",
    "lint-staged": "^17.0.8",
    "prettier": "^3.9.4",
    "rimraf": "^6.1.3",
    "tsup": "^8.5.1",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.62.1",
    "vitest": "^4.1.9"
  }
}
